import { requireAuth } from '@/features/auth/guards/require-auth'
import { ProjectsListPage } from '@/features/projects/pages/projects-list-page'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/projects/')({
  beforeLoad: requireAuth,
  loader: ({ context }) => context.queryClient.ensureQueryData(projectsListQuery()),
  component: ProjectsListPage,
  staticData: { crumb: messages.crumbs.projects },
})
